export default {
  'nav.home': 'الرئيسية',
  'nav.services': 'الخدمات',
  'nav.about': 'من نحن',
  'nav.booking': 'احجز موعداً',
  'nav.call': 'اتصل الآن',
  'nav.whatsapp': 'واتساب',

  'hero.badge': 'فان والمناطق المحيطة · خدمة 24 ساعة',
  'hero.scroll': 'انتقل',
  'hero.slide1.title': 'سباك فان الموثوق',
  'hero.slide1.sub': 'نعمل مع فريق ودود. العنوان الوحيد للجودة.',
  'hero.slide2.title': 'نحن هنا لكل عمل سباكة',
  'hero.slide2.sub': 'من السباكة إلى الغاز الطبيعي، من خدمة الغلاية إلى تنظيف المجاري.',
  'hero.slide3.title': 'حلول سريعة ودائمة',
  'hero.slide3.sub': 'في الوقت المحدد، بدقة وضمان. نخدم فان والمناطق المحيطة.',
  'hero.stat1.value': '+15',
  'hero.stat1.label': 'سنوات خبرة',
  'hero.stat2.value': '3',
  'hero.stat2.label': 'أساتذة خبراء',
  'hero.stat3.value': '+500',
  'hero.stat3.label': 'عمل منجز',
  'hero.stat4.value': '24/7',
  'hero.stat4.label': 'دعم',

  'services.badge': 'خدمات السباكة الاحترافية',
  'services.title': 'خدماتنا',
  'services.highlight': 'المميزة',
  'services.subtitle': 'نقدم حلول سباكة موثوقة وسريعة ودائمة في فان والمناطق المحيطة.',
  'services.viewAll': 'عرض جميع الخدمات',
  'services.detail': 'تفاصيل',
  'services.callBtn': 'اتصل الآن',

  'svc.1.title': 'السباكة الصحية',
  'svc.1.desc': 'خدمات تركيب وتجديد السباكة الصحية الكاملة للمنازل والشركات.',
  'svc.2.title': 'الإصلاح والتجديد',
  'svc.2.desc': 'خدمات إصلاح شاملة لجميع أنواع الأنابيب والتركيبات وأنظمة السباكة.',
  'svc.3.title': 'صيانة الغلاية وتنظيف المشعاع',
  'svc.3.desc': 'حماية نظام التدفئة الخاص بك بصيانة الغلاية وتنظيف المشعاع وإصلاح خزان المياه.',
  'svc.4.title': 'تركيبات الغاز الطبيعي الداخلية',
  'svc.4.desc': 'مد أنابيب الغاز الطبيعي والتوصيل والتركيبات الداخلية بأمان.',
  'svc.5.title': 'تنظيف المجاري',
  'svc.5.desc': 'نحل انسدادات الأحواض والمراحيض والخطوط الرئيسية بسرعة باستخدام آلات احترافية.',
  'svc.6.title': 'إصلاح الحنفيات',
  'svc.6.desc': 'خدمة إصلاح سريعة ودائمة للحنفيات المتسربة أو المعطلة.',
  'svc.7.title': 'أجهزة كشف الأعطال',
  'svc.7.desc': 'نجد التسربات والأعطال الخفية في مواقعها الدقيقة بأجهزة كشف غير مدمرة.',
  'svc.8.title': 'أعمال المجمعات والشقق',
  'svc.8.desc': 'نتولى إدارة وصيانة البنية التحتية للسباكة المشتركة في المباني.',
  'svc.9.title': 'تركيب أنظمة الإطفاء',
  'svc.9.desc': 'تركيب وصيانة أنظمة إطفاء الحرائق والرشاشات للمباني.',

  'whyus.badge': 'لماذا تختارنا؟',
  'whyus.title': 'الجودة والثقة',
  'whyus.highlight': 'معاً',
  'whyus.subtitle': 'تقدم فانبولات تيسيسات خدمة موثوقة لآلاف العملاء في فان منذ سنوات.',
  'feat.1.title': 'عمل مضمون',
  'feat.1.desc': 'جميع أعمال السباكة لدينا مضمونة. تدخل مجاني في حالة حدوث مشاكل.',
  'feat.2.title': 'استجابة سريعة',
  'feat.2.desc': 'نفس اليوم في مركز فان، وأقصر وقت ممكن للمناطق.',
  'feat.3.title': 'مرخص ومؤمن',
  'feat.3.desc': 'جميع أساتذتنا معتمدون، والأعمال تتم بطريقة مؤمنة.',
  'feat.4.title': 'سعر معقول',
  'feat.4.desc': 'تسعير شفاف ومنافس للسوق. لا رسوم خفية.',
  'feat.5.title': 'دعم 24/7',
  'feat.5.desc': 'يمكنك الوصول إلينا عبر واتساب أو الهاتف على مدار الساعة للإصلاحات الطارئة.',
  'feat.6.title': 'معدات احترافية',
  'feat.6.desc': 'حلول سريعة وغير مدمرة مع أجهزة كشف الأعطال والمعدات الحديثة.',

  'team.badge': 'فريقنا',
  'team.title': 'أساتذتنا',
  'team.highlight': 'الخبراء',
  'team.subtitle': 'فريقنا ذو الخبرة والودود دائماً بجانبك.',
  'team.more': 'المزيد عنا',
  'team.role.1': 'أستاذ سباكة ومؤسس',
  'team.role.2': 'أستاذ سباكة',
  'team.role.3': 'أستاذ سباكة',
  'team.desc.1': 'خبير في أنظمة السباكة الصحية والغاز الطبيعي بخبرة تزيد عن 15 عاماً.',
  'team.desc.2': 'أستاذ متمرس في صيانة الغلايات وتنظيف المشعاعات وأعمال التجديد.',
  'team.desc.3': 'متخصص في تنظيف المجاري وكشف الأعطال وتركيبات الغاز الطبيعي.',

  'cta.title': 'هل لديك مشكلة في السباكة؟',
  'cta.subtitle': 'اتصل بنا الآن، سنكون عندك في أقرب وقت ممكن. نخدمك 24 ساعة للإصلاحات الطارئة.',

  'contact.badge': 'التواصل',
  'contact.title': 'تواصل',
  'contact.highlight': 'معنا',
  'contact.subtitle': 'املأ النموذج لأسئلتك أو اتصل بنا مباشرة — سنرد عليك قريباً.',
  'contact.form.title': 'أرسل رسالة',
  'contact.form.name': 'الاسم الكامل *',
  'contact.form.namePH': 'اسمك الكامل',
  'contact.form.phone': 'الهاتف *',
  'contact.form.phonePH': '+90 5XX XXX XXXX',
  'contact.form.email': 'البريد الإلكتروني',
  'contact.form.emailPH': 'example@email.com',
  'contact.form.serviceType': 'نوع الخدمة',
  'contact.form.selectPH': 'اختر',
  'contact.form.message': 'رسالتك *',
  'contact.form.messagePH': 'اشرح مشكلة السباكة أو طلبك بإيجاز...',
  'contact.form.submit': 'إرسال الرسالة',
  'contact.form.sending': 'جاري الإرسال...',
  'contact.success.title': 'تم استلام رسالتك!',
  'contact.success.sub': 'سنتواصل معك في أقرب وقت ممكن.',
  'contact.success.back': 'إرسال رسالة أخرى',
  'contact.loc.label': 'الموقع',
  'contact.loc.value': 'فان والمناطق المحيطة، تركيا',
  'contact.hours.label': 'ساعات العمل',
  'contact.hours.value': 'كل يوم 07:00 – 22:00 (طوارئ: 24/7)',
  'contact.wa.label': 'واتساب',
  'contact.wa.value': '0507 607 4165',
  'contact.svc.0': 'اختر',
  'contact.svc.1': 'السباكة الصحية',
  'contact.svc.2': 'الإصلاح والتجديد',
  'contact.svc.3': 'صيانة الغلاية وتنظيف المشعاع',
  'contact.svc.4': 'تركيبات الغاز الطبيعي الداخلية',
  'contact.svc.5': 'تنظيف المجاري',
  'contact.svc.6': 'إصلاح الحنفيات',
  'contact.svc.7': 'كشف الأعطال',
  'contact.svc.8': 'أعمال المجمعات والشقق',
  'contact.svc.9': 'أنظمة الإطفاء',
  'contact.svc.10': 'أخرى',

  'reviews.badge': 'تقييمات العملاء',
  'reviews.title': 'ماذا يقول',
  'reviews.highlight': 'عملاؤنا؟',
  'reviews.subtitle': 'آلاف العملاء الراضين يروون قصتنا بشكل أفضل مما نستطيع.',
  'reviews.stat.score': 'متوسط التقييم',
  'reviews.stat.clients': 'عميل راضٍ',
  'reviews.stat.satisfaction': 'الرضا',
  'reviews.cta': 'انضم إلى عملائنا الراضين!',
  'review.1.name': 'أحمد ك.',
  'review.1.text': 'الأستاذ إنجين وفريقه يعملون بالوقت المحدد وبدقة. خدمة ودية وموثوقة! أنجزوا أعمال السباكة بشكل مثالي.',
  'review.1.service': 'السباكة الصحية',
  'review.2.name': 'فاطمة ش.',
  'review.2.text': 'أجريت صيانة الغلاية وتنظيف المشعاعات، وتم كل شيء بشكل مثالي وسريع. كانت أسعارهم معقولة جداً أيضاً، أنصح بهم بشدة.',
  'review.2.service': 'صيانة الغلاية',
  'review.3.name': 'محمد أ.',
  'review.3.text': 'تم اكتشاف تسرب المياه بسرعة وبدون مشاكل، أنصح بهم بشدة. وجدوه بأجهزة غير مدمرة وتدخلوا فوراً.',
  'review.3.service': 'كشف الأعطال',
  'review.4.name': 'زينب ت.',
  'review.4.text': 'جددوا حمامي تماماً كما أردت. تعاملوا مع كل شيء من توصيل الغاز فما فوق. راضية جداً!',
  'review.4.service': 'تجديد الحمام',
  'review.5.name': 'إبراهيم ي.',
  'review.5.text': 'أزالوا جميع انسدادات المجاري في مبنانا بالآلات في وقت قصير. فريق احترافي وأساتذة يعرفون عملهم.',
  'review.5.service': 'تنظيف المجاري',

  'footer.desc': 'نعمل بثقة مع موظفينا الودودين. العنوان الوحيد للجودة. خدمات سباكة احترافية في فان والمناطق المحيطة.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.servicesTitle': 'الخدمات',
  'footer.teamTitle': 'أساتذتنا',
  'footer.contactTitle': 'التواصل والموقع',
  'footer.link.home': 'الرئيسية',
  'footer.link.services': 'خدماتنا',
  'footer.link.about': 'من نحن',
  'footer.link.booking': 'احجز موعداً',
  'footer.svc.1': 'السباكة الصحية',
  'footer.svc.2': 'تركيبات الغاز الطبيعي',
  'footer.svc.3': 'صيانة الغلاية',
  'footer.svc.4': 'تنظيف المجاري',
  'footer.svc.5': 'أنظمة الإطفاء',
  'footer.location': 'مركز فان والمناطق المحيطة، تركيا',
  'footer.hours': 'كل يوم 07:00 – 22:00',
  'footer.call': 'اتصل الآن',
  'footer.wa': 'اكتب على واتساب',
  'footer.copyright': '© 2026 Vanpolat Tesisat. جميع الحقوق محفوظة.',
  'footer.area': 'خدمات سباكة احترافية في فان والمناطق المحيطة',

  'sp.hero.badge': 'خدمات السباكة الاحترافية',
  'sp.hero.title': 'خدماتنا',
  'sp.hero.sub': 'فريق فان الموثوق لجميع احتياجات السباكة، من السباكة الصحية إلى الغاز الطبيعي، خدمة الغلاية إلى أنظمة الإطفاء.',
  'sp.grid.title': 'جميع',
  'sp.grid.highlight': 'خدماتنا',
  'sp.grid.subtitle': 'أساتذتنا ذوو الخبرة معك لكل نوع من مشاكل السباكة.',
  'sp.process.title': 'كيف',
  'sp.process.highlight': 'نعمل؟',
  'sp.process.subtitle': 'نحل مشكلتك في 4 خطوات سهلة.',
  'sp.step.1.title': 'اتصل بنا',
  'sp.step.1.desc': 'أبلغ عن طلبك عبر الهاتف أو واتساب.',
  'sp.step.2.title': 'معاينة في الموقع',
  'sp.step.2.desc': 'يأتي أستاذنا إلى عنوانك ويفحص الوضع.',
  'sp.step.3.title': 'عرض سعر مجاني',
  'sp.step.3.desc': 'يُقدَّم لموافقتك بتسعير شفاف.',
  'sp.step.4.title': 'اكتمال العمل',
  'sp.step.4.desc': 'يُنجز العمل بحرفية مضمونة ودقيقة.',

  'ap.hero.badge': 'من نحن',
  'ap.hero.title': 'عائلة فانبولات تيسيسات',
  'ap.hero.sub': 'فريق سباكة متمرس وصادق يخدم كمشروع عائلي في فان منذ سنوات.',
  'ap.story.badge': 'قصتنا',
  'ap.story.title': 'عائلة السباكة الموثوقة في فان',
  'ap.story.p1': 'فانبولات تيسيسات شركة عائلية تعمل في فان منذ أكثر من 15 عاماً. شركتنا التي أسسها إنجين بولات تخدم اليوم مع إخوته حمزة وهيرولله.',
  'ap.story.p2': 'فريقنا الذي يقدم عملاً عالي الجودة في مجال واسع من السباكة الصحية إلى تركيبات الغاز الطبيعي الداخلية، يضع رضا العملاء في المقدمة في كل مشروع.',
  'ap.story.motto': '"نعمل مع موظفين ودودين. العنوان الوحيد للجودة."',
  'ap.cert.1': 'شهادة تركيبات الغاز الطبيعي الداخلية',
  'ap.cert.2': 'شهادة تفويض السباكة الصحية',
  'ap.cert.3': 'شهادة السلامة المهنية',
  'ap.cert.4': 'تفويض خدمة الغلاية',
  'ap.stat.1.value': '+15',
  'ap.stat.1.label': 'سنوات خبرة',
  'ap.stat.2.value': '3',
  'ap.stat.2.label': 'أساتذة خبراء',
  'ap.stat.3.value': '+500',
  'ap.stat.3.label': 'مشاريع منجزة',
  'ap.stat.4.value': '100%',
  'ap.stat.4.label': 'رضا العملاء',
  'ap.values.badge': 'قيمنا',
  'ap.values.title': 'القيم التي',
  'ap.values.highlight': 'تميزنا',
  'val.1.title': 'الموثوقية',
  'val.1.desc': 'نفعل ما نقوله. كل عمل مضمون وصادق.',
  'val.2.title': 'خدمة ودية',
  'val.2.desc': 'نرحب دائماً بعملائنا في بيئة دافئة.',
  'val.3.title': 'جودة العمل',
  'val.3.desc': 'نؤدي العمل بشكل صحيح ودائم في المرة الأولى.',
  'val.4.title': 'الخدمة في الوقت المحدد',
  'val.4.desc': 'نلتزم بالموعد المحدد، نقدر وقت عملائنا.',
  'ap.team.badge': 'فريقنا',
  'ap.team.title': 'تعرف على',
  'ap.team.highlight': 'أساتذتنا',
  'ap.team.subtitle': 'فريق فانبولات المتمرس والودود والمتحمس.',
  'ap.cta.title': 'لدي مشكلة في السباكة، ماذا أفعل الآن؟',
  'ap.cta.sub': 'اتصل بنا الآن أو اكتب على واتساب — فريقنا الودود سيكون عندك في أقرب وقت.',
  'ap.xp': 'سنوات خبرة',

  'lang.tr': 'Türkçe',
  'lang.en': 'English',
  'lang.ar': 'العربية',
};
